module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAM1BMVEUAAAAkJCRAQDg9PThBPTlAPDk9Ozk9Ojg+PDg9Ozo+PTo+PDk+Ozg+Ozk+PDk+PDk+PDngLhBGAAAAEHRSTlMAByA7P0xsbX+FpLS+3/L2tVyeMgAAAHJJREFUGNN9kdsSgCAIRNEyMUn9/69NzcwLtg9ezgCzwwKAIhcaOVIQZcIkE2sDIwXEYQLHYQf5OoXt+YODRhYjWpFsQWmrGHXb9uH49+kxV8trwnm29APWxcLR4eJjdDKq4m1/jz+8WNVisYsYFqHxEd+tqhnz/4zM8QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order/ico_cart.png
// module id = CXyR
// module chunks = 0